/**
 * Setup Guide v2 — Interactive Digital Manual
 * Features: vehicle selector, accordion, wizard nav (mobile),
 *           sidebar nav (desktop), progress tracking, essentials bar
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'hp_setup_guide';

  /* ── State ── */
  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function save(s) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); }
    catch (e) {}
  }
  var state = load();

  /* ── DOM refs ── */
  var allSteps = Array.from(document.querySelectorAll('.sg-step'));
  if (!allSteps.length) return;

  var selectorBtns = document.querySelectorAll('[data-sg-vehicle]');
  var sidebarList = document.getElementById('sg-sidebar-list');
  var wizardNav = document.getElementById('sg-wizard-nav');
  var wizardBack = document.getElementById('sg-wizard-back');
  var wizardNext = document.getElementById('sg-wizard-next');
  var wizardBar = document.getElementById('sg-wizard-bar');
  var essBar = document.querySelector('.sg-essentials');
  var essTgl = essBar ? essBar.querySelector('.sg-essentials__toggle') : null;

  /* ══════════════════════════════════════
     Vehicle Selector
     ══════════════════════════════════════ */
  function setVehicle(v) {
    state.vehicle = v;
    save(state);
    document.body.setAttribute('data-sg-vehicle-active', v);

    selectorBtns.forEach(function (btn) {
      var bv = btn.getAttribute('data-sg-vehicle');
      btn.classList.remove('is-active--car-sedan', 'is-active--truck-suv');
      if (bv === v) btn.classList.add('is-active--' + v);
      btn.setAttribute('aria-checked', bv === v ? 'true' : 'false');
    });

    document.querySelectorAll('.sg-step[data-sg-show]').forEach(function (step) {
      var show = step.getAttribute('data-sg-show');
      step.hidden = (show === 'truck-only' && v !== 'truck-suv') || (show === 'car-only' && v !== 'car-sedan');
    });

    try {
      var url = new URL(window.location);
      url.searchParams.set('vehicle', v);
      history.replaceState(null, '', url);
    } catch (e) {}

    /* Sync mobile strip collapsed label + icon */
    updateVehicleStripLabel(v);

    buildSidebar();
    updateWizard();
  }

  /* Re-query buttons each time so dynamically-added strip/sidebar buttons work too */
  function bindSelectorButtons() {
    var btns = document.querySelectorAll('[data-sg-vehicle]');
    btns.forEach(function (btn) {
      if (btn.__sgBound) return;
      btn.__sgBound = true;
      btn.addEventListener('click', function () {
        setVehicle(this.getAttribute('data-sg-vehicle'));
        /* Collapse the mobile strip after selection */
        var strip = document.getElementById('sg-vehicle-strip');
        if (strip && strip.getAttribute('data-sg-strip-state') === 'expanded') {
          strip.setAttribute('data-sg-strip-state', 'visible');
          var tgl = document.getElementById('sg-vehicle-strip-toggle');
          if (tgl) tgl.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }
  bindSelectorButtons();

  /* ══════════════════════════════════════
     Mobile Vehicle Strip — show/hide + expand/collapse
     ══════════════════════════════════════ */
  var stripEl = document.getElementById('sg-vehicle-strip');
  var stripToggle = document.getElementById('sg-vehicle-strip-toggle');
  var stripName = document.getElementById('sg-vehicle-strip-name');
  var stripIcon = document.getElementById('sg-vehicle-strip-icon');
  var heroSelector = document.querySelector('.sg-selector-row');

  var VEHICLE_ICONS = {
    'car-sedan': '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 22h20M6 22a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm20 0a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"/><path d="M6 22v-6a2 2 0 012-2h1.5l2.5-5h8l2.5 5H24a2 2 0 012 2v6"/></svg>',
    'truck-suv': '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 8h18v14H2z"/><path d="M20 13h5l4 4v5h-9V13z"/><circle cx="7" cy="24" r="2.5"/><circle cx="23" cy="24" r="2.5"/></svg>'
  };
  var VEHICLE_NAMES = { 'car-sedan': 'Car/Sedan', 'truck-suv': 'Truck/SUV' };

  function updateVehicleStripLabel(v) {
    if (!stripName || !stripIcon) return;
    stripName.textContent = VEHICLE_NAMES[v] || 'Select vehicle';
    if (VEHICLE_ICONS[v]) stripIcon.innerHTML = VEHICLE_ICONS[v];
  }

  if (stripEl && stripToggle) {
    stripToggle.addEventListener('click', function () {
      var expanded = stripEl.getAttribute('data-sg-strip-state') === 'expanded';
      stripEl.setAttribute('data-sg-strip-state', expanded ? 'visible' : 'expanded');
      stripToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  }

  if (stripEl && heroSelector && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var state = stripEl.getAttribute('data-sg-strip-state');
        if (e.isIntersecting) {
          /* Hero selector visible → hide strip */
          stripEl.setAttribute('data-sg-strip-state', 'hidden');
          stripEl.setAttribute('aria-hidden', 'true');
        } else {
          /* Hero selector off-screen → reveal (collapsed by default) */
          if (state !== 'expanded') stripEl.setAttribute('data-sg-strip-state', 'visible');
          stripEl.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0, rootMargin: '-40px 0px 0px 0px' });
    io.observe(heroSelector);
  }

  /* ══════════════════════════════════════
     Visible Steps Helper
     ══════════════════════════════════════ */
  function visibleSteps() {
    return allSteps.filter(function (s) {
      if (s.hidden) return false;
      /* Exclude non-numeric steps (App, Troubleshooting) from wizard navigation */
      var num = s.getAttribute('data-sg-step');
      return num && /^\d+$/.test(num);
    });
  }

  /* All steps including non-numeric (for accordion/sidebar) */
  function allVisibleSteps() {
    return allSteps.filter(function (s) { return !s.hidden; });
  }

  function activeIndex() {
    var vis = visibleSteps();
    for (var i = 0; i < vis.length; i++) {
      if (vis[i].classList.contains('is-open')) return i;
    }
    return -1;
  }

  /* ══════════════════════════════════════
     Accordion
     ══════════════════════════════════════ */
  function openStep(step, scroll) {
    if (!step) return;
    allSteps.forEach(function (s) {
      if (s !== step) {
        s.classList.remove('is-open');
        var h = s.querySelector('.sg-step__header');
        if (h) h.setAttribute('aria-expanded', 'false');
      }
    });
    var wasOpen = step.classList.contains('is-open');
    step.classList.toggle('is-open', !wasOpen);
    var header = step.querySelector('.sg-step__header');
    if (header) header.setAttribute('aria-expanded', !wasOpen ? 'true' : 'false');

    if (!wasOpen && scroll !== false) {
      setTimeout(function () {
        step.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 60);
    }
    updateSidebarActive();
    updateWizard();
  }

  function toggleCheck(step) {
    var stepId = step.getAttribute('data-sg-step');
    var checked = !step.classList.contains('is-checked');
    step.classList.toggle('is-checked', checked);
    var num = step.querySelector('.sg-step__num');
    if (num) num.setAttribute('aria-checked', checked ? 'true' : 'false');
    if (checked) state['s' + stepId] = true;
    else delete state['s' + stepId];
    save(state);
    updateSidebarChecked();
  }

  allSteps.forEach(function (step) {
    var header = step.querySelector('.sg-step__header');
    if (!header) return;
    var num = step.querySelector('.sg-step__num');
    var stepId = step.getAttribute('data-sg-step');

    if (state['s' + stepId]) step.classList.add('is-checked');

    header.addEventListener('click', function (e) {
      if (num && (num.contains(e.target) || e.target === num)) {
        e.preventDefault();
        toggleCheck(step);
        return;
      }
      openStep(step);
    });

    if (num) {
      num.setAttribute('tabindex', '0');
      num.setAttribute('role', 'checkbox');
      num.setAttribute('aria-checked', state['s' + stepId] ? 'true' : 'false');
      num.setAttribute('aria-label', 'Mark step ' + stepId + ' complete');
      num.addEventListener('click', function (e) { e.stopPropagation(); toggleCheck(step); });
      num.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); toggleCheck(step); }
      });
    }
  });

  /* ══════════════════════════════════════
     Desktop Sidebar Nav
     ══════════════════════════════════════ */
  function buildSidebar() {
    if (!sidebarList) return;
    sidebarList.innerHTML = '';
    var phaseHeaders = document.querySelectorAll('.sg-phase-header');
    var vis = visibleSteps();

    phaseHeaders.forEach(function (ph) {
      var style = ph.querySelector('.sg-phase-header__label--deploy') ? 'deploy' : 'setup';
      var label = ph.querySelector('.sg-phase-header__label');
      var title = ph.querySelector('.sg-phase-header__title');
      var li = document.createElement('li');
      li.className = 'sg-sidebar__item';
      li.innerHTML = '<div class="sg-sidebar__divider sg-sidebar__divider--' + style + '">' +
        (label ? label.textContent : '') + ': ' + (title ? title.textContent : '') + '</div>';
      sidebarList.appendChild(li);
    });

    /* Rebuild sidebar from all rendered elements (Shopify wraps blocks in .shopify-block divs) */
    sidebarList.innerHTML = '';

    /* Query all phase headers, milestones, and steps in DOM order within .sg-content */
    var contentEl = document.getElementById('sg-content') || document.querySelector('.sg-content');
    if (!contentEl) return;
    var allElements = contentEl.querySelectorAll('.sg-phase-header, .sg-milestone, .sg-step');

    allElements.forEach(function (el) {
      if (el.classList.contains('sg-phase-header')) {
        var phStyle = el.querySelector('.sg-phase-header__label--deploy') ? 'deploy' : 'setup';
        var phLabel = el.querySelector('.sg-phase-header__label');
        var phTitle = el.querySelector('.sg-phase-header__title');
        var divLi = document.createElement('li');
        divLi.className = 'sg-sidebar__item';
        divLi.innerHTML = '<div class="sg-sidebar__divider sg-sidebar__divider--' + phStyle + '">' +
          (phLabel ? phLabel.textContent.trim() : '') + ' — ' + (phTitle ? phTitle.textContent.trim() : '') + '</div>';
        sidebarList.appendChild(divLi);
      }

      if (el.classList.contains('sg-milestone')) {
        var mLi = document.createElement('li');
        mLi.className = 'sg-sidebar__item';
        var mTitle = el.querySelector('.sg-milestone__title');
        mLi.innerHTML = '<div class="sg-sidebar__divider" style="color: var(--sg-success);">✓ ' +
          (mTitle ? mTitle.textContent.trim() : 'Milestone') + '</div>';
        sidebarList.appendChild(mLi);
      }

      if (el.classList.contains('sg-step') && !el.hidden) {
        var stepNum = el.getAttribute('data-sg-step');
        var stepTitle = el.querySelector('.sg-step__title');
        var sLi = document.createElement('li');
        sLi.className = 'sg-sidebar__item';
        var btn = document.createElement('button');
        btn.className = 'sg-sidebar__link';
        btn.setAttribute('data-sidebar-step', stepNum);
        if (el.classList.contains('is-checked')) btn.classList.add('is-checked');
        btn.innerHTML = '<span class="sg-sidebar__link-num">' + stepNum + '</span>' +
          '<span class="sg-sidebar__link-title">' + (stepTitle ? stepTitle.textContent.trim() : 'Step ' + stepNum) + '</span>';
        btn.addEventListener('click', (function (s) {
          return function () { openStep(s); };
        })(el));
        sLi.appendChild(btn);
        sidebarList.appendChild(sLi);
      }
    });

    updateSidebarActive();
  }

  function updateSidebarActive() {
    if (!sidebarList) return;
    var links = sidebarList.querySelectorAll('.sg-sidebar__link');
    links.forEach(function (l) {
      var sn = l.getAttribute('data-sidebar-step');
      var step = document.querySelector('.sg-step[data-sg-step="' + sn + '"]');
      l.classList.toggle('is-active', step && step.classList.contains('is-open'));
    });
  }

  function updateSidebarChecked() {
    if (!sidebarList) return;
    var links = sidebarList.querySelectorAll('.sg-sidebar__link');
    links.forEach(function (l) {
      var sn = l.getAttribute('data-sidebar-step');
      var step = document.querySelector('.sg-step[data-sg-step="' + sn + '"]');
      l.classList.toggle('is-checked', step && step.classList.contains('is-checked'));
    });
  }

  /* ══════════════════════════════════════
     Mobile Wizard Nav
     ══════════════════════════════════════ */
  var wizardCounter = document.getElementById('sg-wizard-counter');

  function updateWizard() {
    if (!wizardBar) return;
    var vis = visibleSteps();
    var idx = activeIndex();
    var total = vis.length;
    if (total === 0) return;
    var pct = ((idx + 1) / total) * 100;
    wizardBar.style.width = Math.max(pct, 5) + '%';

    if (wizardCounter) {
      wizardCounter.textContent = 'Step ' + (idx + 1) + ' of ' + total;
    }

    if (wizardBack) wizardBack.disabled = (idx <= 0);
  }

  if (wizardBack) {
    wizardBack.addEventListener('click', function () {
      var vis = visibleSteps();
      var idx = activeIndex();
      if (idx > 0) openStep(vis[idx - 1]);
    });
  }
  if (wizardNext) {
    wizardNext.addEventListener('click', function () {
      var vis = visibleSteps();
      var idx = activeIndex();
      if (idx >= 0 && idx < vis.length) {
        toggleCheck(vis[idx]);
      }
      if (idx < vis.length - 1) {
        openStep(vis[idx + 1]);
      }
    });
  }

  /* ══════════════════════════════════════
     5 Essentials Bar
     ══════════════════════════════════════ */
  if (essTgl) {
    essTgl.addEventListener('click', function () {
      var expanded = essBar.classList.toggle('is-expanded');
      essTgl.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  /* ══════════════════════════════════════
     Sidebar Top — track header visibility
     ══════════════════════════════════════ */
  (function () {
    var header = document.querySelector('.header--sticky');
    if (!header) return;
    var headerH = header.offsetHeight || 96;
    var root = document.documentElement;

    function updateSidebarTop() {
      var hidden = header.classList.contains('is-hidden');
      root.style.setProperty('--sg-sidebar-top', hidden ? '12px' : (headerH + 8) + 'px');
    }

    var observer = new MutationObserver(updateSidebarTop);
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
    updateSidebarTop();
  })();

  /* ══════════════════════════════════════
     Init
     ══════════════════════════════════════ */
  var urlV = (new URLSearchParams(window.location.search)).get('vehicle');
  setVehicle(urlV || state.vehicle || 'car-sedan');

  /* Open first unchecked step */
  var vis = visibleSteps();
  var opened = false;
  for (var i = 0; i < vis.length; i++) {
    if (!vis[i].classList.contains('is-checked')) {
      openStep(vis[i], false);
      opened = true;
      break;
    }
  }
  if (!opened && vis.length) openStep(vis[0], false);
})();